var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDireactionUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "direaction up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 175 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5856 5.46849C11.3269 5.79194 10.8549 5.84438 10.5315 5.58562L5.99997 1.96044L1.46849 5.58562C1.14505 5.84438 0.673077 5.79194 0.41432 5.46849C0.155562 5.14505 0.208004 4.67308 0.53145 4.41432L5.53145 0.414321C5.80536 0.19519 6.19458 0.19519 6.46849 0.414321L11.4685 4.41432C11.7919 4.67308 11.8444 5.14505 11.5856 5.46849Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDireactionUp);
export default __webpack_public_path__ + "static/media/direaction-up.bf168de87027c8ab4ab6abf9ddd35846.svg";
export { ForwardRef as ReactComponent };